import { useEffect, useState } from 'react';

type Theme = 'light' | 'dark';

function readStored(): Theme | null {
  if (typeof window === 'undefined') return null;
  const v = localStorage.getItem('opensoi.theme');
  return v === 'light' || v === 'dark' ? v : null;
}

export function ThemeToggle() {
  const [theme, setTheme] = useState<Theme>(() => {
    if (typeof window === 'undefined') return 'light';
    return (
      readStored() ??
      (window.matchMedia('(prefers-color-scheme: dark)').matches ? 'dark' : 'light')
    );
  });

  useEffect(() => {
    if (typeof document === 'undefined') return;
    document.documentElement.setAttribute('data-theme', theme);
    localStorage.setItem('opensoi.theme', theme);
  }, [theme]);

  const next = theme === 'dark' ? 'light' : 'dark';
  return (
    <button
      type="button"
      aria-label="Toggle dark mode"
      className="grid h-11 w-11 place-items-center rounded-pill text-ink hover:bg-soi-100"
      onClick={() => setTheme(next)}
    >
      <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
        <path d="M21 12.79A9 9 0 1 1 11.21 3 7 7 0 0 0 21 12.79z" />
      </svg>
    </button>
  );
}
